// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  clerkUserId: __t.string().name("clerk_user_id"),
  firstName: __t.string().name("first_name"),
  lastName: __t.string().name("last_name"),
  phone: __t.string(),
  dob: __t.string(),
  citizenship: __t.string(),
  residency: __t.string(),
  get address() {
    return CanonicalAddress;
  },
});
